import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'

import { evalCondition } from 'mailup-react-helpers'
import {
  Button,
  Flex,
  SPACING_40,
  SpacingVertical,
  TOAST_VARIANT_ERROR,
  TOAST_VARIANT_INFO,
  TOAST_VARIANT_WARNING,
  toastDismiss,
  toastShow
} from 'mailup-web-components'
import BoxSearchCriteria from './step3/BoxSearchCriteria'
import BoxResults from './step3/ResultsPreview/BoxResults'
import SendingsLimitWarningMessage from './step3/SendingsLimitWarningMessage'

import {
  initSearchCriteriaCallback,
  searchRecipientsAndSendingPreviewDataCallback,
  startQueueAndGoToStep4Callback
} from '../recoil/callbacks/callbacks'
import {
  abTestState,
  recipientsDataTablePreviewState,
  searchCriteriaState,
  sendingPreviewState
} from '../recoil/state/abtest'
import { pageState } from '../recoil/state/page'

import { EMIAL_REGEX } from 'Constants/'
import {
  RECIPIENTS_ALL,
  RECIPIENTS_GROUP_FILTER,
  RECIPIENTS_TEST_GROUP
} from '../const'

const AbTestWizard3Step = () => {
  const intl = useIntl()
  const { id, step2, step3, step1 } = useRecoilValue(abTestState)
  const [{ loadedStep3, goToWizardStep4 }, setPageState] = useRecoilState(
    pageState
  )
  const initSearchCriteria = useRecoilCallback(initSearchCriteriaCallback, [])
  const { loaded } = useRecoilValue(searchCriteriaState)
  const { items, firstChange } = useRecoilValue(recipientsDataTablePreviewState)
  const {
    oldIncludeGroups,
    oldExcludeGroups,
    oldSelectedFilters,
    totalRecipients,
    toBeQueued
  } = useRecoilValue(sendingPreviewState)
  const searchRecipientsAndSendingPreviewData = useRecoilCallback(
    searchRecipientsAndSendingPreviewDataCallback,
    []
  )
  const startQueueAndGoToStep4 = useRecoilCallback(
    startQueueAndGoToStep4Callback,
    []
  )
  useEffect(() => {
    !loadedStep3 && initSearchCriteria()
  }, [loadedStep3])

  useEffect(() => {
    initSearchCriteria()
  }, [step2.recipients])

  const handleBack = () => {
    setPageState(prev => ({
      ...prev,
      wizardStep: 2
    }))
  }

  const handleContinue = () => {
    if (!firstChange) {
      // atLeastOne preview
      const iG =
        step3.includeGroups
          .slice()
          .sort()
          .toString() ===
        oldIncludeGroups
          .slice()
          .sort()
          .toString()
      const eG =
        step3.excludeGroups
          .slice()
          .sort()
          .toString() ===
        oldExcludeGroups
          .slice()
          .sort()
          .toString()
      const sF =
        step3.selectedFilters
          .slice()
          .sort()
          .toString() ===
        oldSelectedFilters
          .slice()
          .sort()
          .toString()
      const equalFilters = (iG === eG) === sF
      if (!equalFilters) {
        searchRecipientsAndSendingPreviewData().then(e => {
          setPageState(prev => ({
            ...prev,
            goToWizardStep4: true
          }))
        })
      } else {
        setPageState(prev => ({
          ...prev,
          goToWizardStep4: true
        }))
      }
    } else {
      searchRecipientsAndSendingPreviewData().then(e => {
        setPageState(prev => ({
          ...prev,
          goToWizardStep4: true
        }))
      })
    }
  }

  const isDisabled = () => {
    let res = false
    if (step2.recipients === RECIPIENTS_ALL) {
      res = false
    } else {
      res = !(
        loaded &&
        (step3.includeGroups.length > 0 ||
          step3.excludeGroups.length > 0 ||
          step3.selectedFilters.length > 0) &&
        // se esiste items deve essere il suo length altrimenti è sempre true, quando è all non fa la chiamat
        (items ? items.length > 0 : true)
      )
    }
    if (res) {
      res = stepControllerToast()
    }
    return res
  }

  const stepControllerToast = () => {
    // Se "Change sender according to recipient" == OFF && SenderName=="" => toast danger Load.EmailSendingWizard.errNome
    if (!step2.senderInfo.customSender && step2.senderInfo.senderName === '') {
      toastShow(
        intl.formatMessage({ id: 'Load.EmailSendingWizard.errNome' }),
        TOAST_VARIANT_ERROR,
        'LoadEmailSendingWizarderrNome'
      )
      return false
    }
    // Se SenderEmail=="" => toast danger Load.EmailSendingWizard.errEmail
    if (step2.senderInfo.senderEmail === '') {
      toastShow(
        intl.formatMessage({ id: 'Load.EmailSendingWizard.errEmail' }),
        TOAST_VARIANT_ERROR,
        'LoadEmailSendingWizarderrEmail'
      )
      return false
    }
    // Se SenderEmail not valid (regexp) => toast danger Load.EmailSendingWizard.errEmail2
    if (step2.senderInfo.senderEmail.match(EMIAL_REGEX)) {
      toastShow(
        intl.formatMessage({ id: 'Load.EmailSendingWizard.errEmail2' }),
        TOAST_VARIANT_ERROR,
        'LoadEmailSendingWizarderrEmail2'
      )
      return false
    }
    // Se  listType != 'Pec' &&  SenderEmail non verificato (trusted sender…) => toast danger Load.EmailSendingWizard.trustedEmailSenderWarning
    if (step2.senderInfo.isPEC && !step2.senderInfo.senderEmail) {
      toastShow(
        intl.formatMessage({
          id: 'Load.EmailSendingWizard.trustedEmailSenderWarning'
        }),
        TOAST_VARIANT_ERROR,
        'LoadEmailSendingWizardtrustedEmailSenderWarning'
      )
      return false
    }

    // Se ReplyTo=="" => toast danger Load.EmailSendingWizard.errEmail4
    if (step2.senderInfo.replyToEmail.match(EMIAL_REGEX)) {
      toastShow(
        intl.formatMessage({ id: 'Load.EmailSendingWizard.errEmail4' }),
        TOAST_VARIANT_ERROR,
        'LoadEmailSendingWizarderrEmail4'
      )
      return false
    }

    return true
  }

  useEffect(() => {
    // chiudo i toast
    toastDismiss('LoadEmailSendingWizardSelectRecipError')
    toastDismiss('LoadEmailSendingWizarderrSendLimitReached')
    toastDismiss('tooLittlePoolABTest')

    if (goToWizardStep4) {
      // vuol dire che il controllo è avvenuto in automatico
      const res = (toBeQueued * step1.percTest) / 100
      let singleMessageTestPoolCount = Math.floor(
        res / step1.abTestMessages.length
      )

      if (
        isDisabled() ||
        toBeQueued === 0 ||
        toBeQueued === -900 ||
        singleMessageTestPoolCount === 0
      ) {
        if (step3.trialRecipientLimit > 0) {
          onTrialRecipientLimit()
        }
        if (toBeQueued === 0) {
          toastShow(
            getSelectRecipError(),
            TOAST_VARIANT_ERROR,
            'LoadEmailSendingWizardSelectRecipError'
          )
        }
        if (toBeQueued === -900) {
          toastShow(
            intl.formatMessage({
              id: 'Load.EmailSendingWizard.errSendLimitReached'
            }),
            TOAST_VARIANT_ERROR,
            'LoadEmailSendingWizarderrSendLimitReached'
          )
        }
        if (singleMessageTestPoolCount === 0) {
          // const singleMessageTestPoolCount = Math.floor(
          //   ((toBeQueued * step1.percTest) / 100) / step1.abTestMessages.length
          // )
          let i = 0
          let x = 0
          const percTest = step1.percTest < 5 ? 5 : step1.percTest
          while (singleMessageTestPoolCount === 0) {
            i++
            x = toBeQueued + i
            const tmp = (x * percTest) / 100
            singleMessageTestPoolCount = Math.floor(
              tmp / step1.abTestMessages.length
            )
          }
          toastShow(
            intl.formatMessage(
              {
                id: 'Load.ABTestWizard.WarningTooFewRecipients'
              },
              {
                X: x
              }
            ),
            TOAST_VARIANT_ERROR,
            'tooLittlePoolABTest'
          )
        }
      } else {
        startQueueAndGoToStep4(id)
      }
      // reset
      setPageState(prev => ({
        ...prev,
        goToWizardStep4: false
      }))
    }
  }, [goToWizardStep4])

  const onTrialRecipientLimit = () => {
    const goToMShop = evalCondition(
      'uo:GEST AND NOT c:IsRetailer AND NOT c:IsDeveloper AND NOT co:TURNOFFMSHOP'
    )
    toastShow(
      <SendingsLimitWarningMessage
        trialRecipientLimit={step3.trialRecipientLimit}
        selectedRecipients={totalRecipients}
        goToMShop={goToMShop}
      />,
      step3.trialRecipientLimit > totalRecipients
        ? TOAST_VARIANT_INFO
        : TOAST_VARIANT_WARNING,
      'trialSendingsLimitWarning',
      true
    )
  }

  const getSelectRecipError = () => {
    return (
      <>
        {intl.formatMessage(
          { id: 'Load.EmailSendingWizard.SelectRecipError' },
          { linebreak: <br /> }
        )}
      </>
    )
  }

  return (
    <>
      {(step2.recipients === RECIPIENTS_GROUP_FILTER ||
        step2.recipients === RECIPIENTS_TEST_GROUP) && <BoxSearchCriteria />}
      <BoxResults />
      <Flex justifyContent='space-between'>
        <Button data-mu-test='btn-back' kind='secondary' onClick={handleBack}>
          {intl.formatMessage({ id: 'Load.EmailSendingWizard.BtnBack' })}
        </Button>
        <Button
          data-mu-test='btn-continue'
          kind='primary'
          onClick={handleContinue}
          disabled={isDisabled()}
        >
          {intl.formatMessage({
            id: 'Load.EmailSendingWizard.BtnContinue'
          })}
        </Button>
      </Flex>
      <SpacingVertical variant={SPACING_40} />
    </>
  )
}

export default AbTestWizard3Step
